import { render, staticRenderFns } from "./BmPedidoEditar.vue?vue&type=template&id=c46933a8&"
import script from "./BmPedidoEditar.vue?vue&type=script&lang=js&"
export * from "./BmPedidoEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports